__turbopack_context__.v({
  "loading-button": "FollowLoadingButton-module-scss-module__S5rLMq__loading-button",
  "loading-button--compact": "FollowLoadingButton-module-scss-module__S5rLMq__loading-button--compact",
  "loading-button--mini": "FollowLoadingButton-module-scss-module__S5rLMq__loading-button--mini",
  "loading-button__container": "FollowLoadingButton-module-scss-module__S5rLMq__loading-button__container",
  "loading-button__main": "FollowLoadingButton-module-scss-module__S5rLMq__loading-button__main",
  "loadingCardSwipeX": "FollowLoadingButton-module-scss-module__S5rLMq__loadingCardSwipeX",
});
